<ng-container *ngIf="displayValue">
    {{valueToDisplay | number:'1.2'}}
</ng-container>
<ng-container *ngIf="!displayValue">
    -
</ng-container>
